<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Amount -->
    <amount-field
      v-model="$attrs.transaction.amount"
      :error="$attrs.errors.transaction.amount"
    />

    <!-- Transaction type -->
    <transaction-type-field
      v-model="$attrs.transaction.transaction_type"
      :error="$attrs.errors.transaction.transaction_type"
    />

    <!-- Datetime -->
    <date-time-field
      v-model="$attrs.transaction.datetime"
      :error="$attrs.errors.transaction.datetime"
    />

    <!-- Notation -->
    <notation-field
      v-model="$attrs.transaction.notation"
      :error="$attrs.errors.transaction.notation"
    />

    <!-- Client -->
    <client-field
      v-model="$attrs.transaction.client"
      :error="$attrs.errors.transaction.client"
      v-show="!($attrs.transaction.client)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import amountField from '@/components/forms/transaction/fields/Amount'
import transactionTypeField from '@/components/forms/transaction/fields/TransactionType'
import dateTimeField from '@/components/forms/transaction/fields/DateTime'
import notationField from '@/components/forms/transaction/fields/Notation'
import clientField from '@/components/forms/transaction/fields/Client'

export default {
  name: 'transaction-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    amountField,
    transactionTypeField,
    dateTimeField,
    notationField,
    clientField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// TransactionBlankForm.vue?ccb46960